import { C1MoreButtonOptionProps } from 'components/core/button'
import { getSelfApprovalEnabled, getSelfProvisionEnabled } from 'components/pages/policy/detail/PolicyStep'
import {
    approveOption,
    approveWithCommentOption,
    cancelOption,
    commentOption,
    deleteOption,
    denyOption,
    denyWithCommentOption,
    markProvisionComplete,
    markProvisionErrored,
    reassignOption,
    restartOption,
    TaskOptionsArgs,
} from 'components/pages/task/dropdown'
import { TaskValue } from 'lib/actions/task'

export const taskOptions = ({
    intl,
    router,
    task,
    onAction,
    taskSvc,
    dispatch,
    setOpenDialog,
    hasFeature,
    setTaskActionTask,
}: TaskOptionsArgs): C1MoreButtonOptionProps[] => {
    const instance = task.policy?.current?.instance

    const options: ((TaskOptionsArgs) => C1MoreButtonOptionProps)[] = []
    if (instance?.oneofKind === 'approval') {
        options.push(approveOption, approveWithCommentOption, denyOption, denyWithCommentOption)
    } else {
        options.push(markProvisionComplete, markProvisionErrored)
    }

    options.push(commentOption, reassignOption, restartOption, cancelOption, deleteOption)

    return options.map((f) => {
        const opt = f({ intl, router, task, onAction, taskSvc, dispatch, setOpenDialog, hasFeature, setTaskActionTask })
        // If a reason is required, these options that don't require a comment are disabled.
        if (instance?.oneofKind === 'approval') {
            if (instance?.approval.approval?.requireApprovalReason) {
                if (opt.key === `components_task_list_approve_option_${task.id}`) {
                    opt.disabled = true
                }
            }
            if (instance?.approval.approval?.requireDenialReason) {
                if (opt.key === `components_task_list_deny_option_${task.id}`) {
                    opt.disabled = true
                }
            }
        }

        return opt
    })
}

export const secondaryTaskOptions = ({
    intl,
    router,
    task,
    onAction,
    taskSvc,
    dispatch,
    setOpenDialog,
    hasFeature,
    setTaskActionTask,
}: TaskOptionsArgs): C1MoreButtonOptionProps[] => {
    const instance = task.policy?.current?.instance

    const options: ((TaskOptionsArgs) => C1MoreButtonOptionProps)[] = []
    if (instance?.oneofKind === 'approval') {
        options.push(approveWithCommentOption, denyWithCommentOption)
    } else {
        options.push(markProvisionComplete, markProvisionErrored)
    }

    options.push(commentOption, reassignOption, restartOption, cancelOption, deleteOption)

    return options.map((f) => {
        const opt = f({ intl, router, task, onAction, taskSvc, dispatch, setOpenDialog, hasFeature, setTaskActionTask })
        // These options aren't really in the array, but we disable them anyway as a precaution.
        if (instance?.oneofKind === 'approval') {
            if (instance?.approval.approval?.requireApprovalReason) {
                if (opt.key === `components_task_list_approve_option_${task.id}`) {
                    opt.disabled = true
                }
            }
            if (instance?.approval.approval?.requireDenialReason) {
                if (opt.key === `components_task_list_deny_option_${task.id}`) {
                    opt.disabled = true
                }
            }
        }

        return opt
    })
}

export const isSelfActionAllowed = (task?: TaskValue): boolean => {
    if (
        task?.policy?.current?.instance.oneofKind === 'approval' &&
        task.policy.current.instance.approval.approval !== undefined
    ) {
        return getSelfApprovalEnabled(task.policy.current.instance.approval.approval)
    }

    if (
        task?.policy?.current?.instance.oneofKind === 'provision' &&
        task.policy.current.instance.provision.provision !== undefined
    ) {
        return getSelfProvisionEnabled(task.policy.current.instance.provision.provision)
    }
    if (task?.policy?.current?.instance.oneofKind === 'form') {
        return true
    }

    return false
}
